module.exports = __webpack_public_path__ + "promotion_featured.png?5f92a4e0e843f2b3ba714a86724bab20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion_featured.png
// module id = 995
// module chunks = 2